import { PageTransfersAchImportView } from './View';

export const ACH_IMPORTS = {
  AchImportView: PageTransfersAchImportView,
} as const;
